import { AxiosError } from 'axios';
import { GET_ENABLED_REQUEST_TYPES_URL } from '../../constants/apiUrls';
import { GET_ENABLED_REQUEST_TYPES_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { PaginatedData } from '../../models/List';
import { ApiPathParam } from '../../models/SearchParamSchema';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface EnabledRequestTypeResponse {
  name: string;
  dateTime: string;
  requestTypeModels: PaginatedData<RequestType>;
}

export interface RequestType {
  accessArrangementType: string;
  modeOfAssessment: string;
  uuidOfType: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  params: ApiPathParam;
  onSuccess?: (data: EnabledRequestTypeResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetEnabledRequestTypes = ({ params, onSuccess, onError }: Input) => {
  const getEnabledRequestTypes = async () => {
    const res = await axiosClient.get<EnabledRequestTypeResponse>(
      GET_ENABLED_REQUEST_TYPES_URL(params)
    );
    return res.data;
  };

  return useCustomQuery(GET_ENABLED_REQUEST_TYPES_QUERY_KEY, getEnabledRequestTypes, {
    onSuccess,
    onError,
  });
};
